const levels = {
  'trace' : 4,
  'debug' : 3,
  'info'  : 2,
  'warn'  : 1,
  'error' : 0,
  '0'     : 0,
  '1'     : 1,
  '2'     : 2,
  '3'     : 3,
  '4'     : 4
};

const reverseLevels = {
  0: 'error',
  1: 'warn',
  2: 'info',
  3: 'debug',
  4: 'trace',
};

export class Logger {

  private name = "default";
  private logLevel: number;
  private logClass: string;

  constructor(name: string, logLevel?: string) {
    this.name = name || this.name;
    this.logLevel = this.stringToLogLevel(logLevel || 'info');
  }

  setLogLevel(level: number | string) {
    this.logLevel = this.stringToLogLevel(String(level));
  }

  getLogLevelString(): string {
    return reverseLevels[this.logLevel];
  }

  getLogLevel(): number {
    return this.logLevel;
  }

  trace(message: string| any, ...args: any[]) {
    this.log(message, 'trace', 4, args);
  }

  debug(message: string| any, ...args: any[]) {
    this.log(message, 'debug', 4, args);
  }

  info(message: string| any, ...args: any[]) {
    this.log(message, 'info', 4, args);
  }

  warn(message: string| any, ...args: any[]) {
    this.log(message, 'warn', 4, args);
  }

  error(message: string| any, ...args: any[]) {
    this.log(message, 'error', 4, args);
  }

  isTraceEnabled(): boolean {
    return this.getLogLevel() >= 4;
  }

  isDebugEnabled(): boolean {
    return this.getLogLevel() >= 3;
  }

  isInfoEnabled(): boolean {
    return this.getLogLevel() >= 2;
  }

  isWarnEnabled(): boolean {
    return this.getLogLevel() >= 1;
  }

  private log(message: string | any, prefix: string = 'info', level: number = 3, args: string[] = []) {
    if (level < this.getLogLevel()) {
      return;
    }

    this.logClass = this.logClass || 'ClientJavaScript';

    if (level >= 0 && level <= 4) {

      const isoString = this.toISOString();
      let logString = `${isoString} ${this.name} ${prefix.toUpperCase()}: `;
      if (typeof(message) === 'object') {
        logString += "LOGGING OBJECT VALUE";
        console.log(this.format(logString, args));
        console.log(message);
      } else {
        logString += message;
        console.log(this.format(logString, args));
      }
    }
  }

  private stringToLogLevel(stringLevel: string): number {
    return levels[stringLevel] || 0;
  }

  private toISOString(): string {
    const pad = (n: number) => { return n < 10 ? '0' + n : n };
    const date: Date = new Date();
    return date.getUTCFullYear() + '-'
      + pad(date.getUTCMonth() + 1) + '-'
      + pad(date.getUTCDate()) + 'T'
      + pad(date.getUTCHours()) + ':'
      + pad(date.getUTCMinutes()) + ':'
      + pad(date.getUTCSeconds()) + 'Z';
  }

  private format(message: string, args: any[] = []): string {
    let index = -1;

    return message.replace(/\{(\d*?)\}/g, function(match, number) {
      index++;

      var indexToUse = (number == "") ? index : number;

      return typeof args[indexToUse] != 'undefined'
        ? args[indexToUse]
        : match
        ;
    });
  }
}
